import type { ModalManager } from "@/modal-manager";

import { modalConfig } from "./constants";
import type { FetchAndOpenModalOptions, ModalConfig } from "./types";

export const registerModals = (
    modalManager: ModalManager,
    config: ModalConfig = modalConfig
): void =>
    Object.values(config).forEach(({ token }) => modalManager.addModal(token));

/**
 * Dynamically imports and opens the specified rewards modal.
 * @param modalName - The name of the modal to open.
 * @param params - Parameters to pass to the modal.
 * @param modalManager - The modal manager instance to handle the modal.
 * @param dynamicImportManager - The dynamic import manager to fetch the modal definition.
 * @returns A promise that resolves when the modal is opened.
 */
export const fetchAndOpenModal = async ({
    modalName,
    modalManager,
    dynamicImportManager,
    params,
    config = modalConfig,
}: FetchAndOpenModalOptions) => {
    await dynamicImportManager.fetch({
        definition: config[modalName].definition,
    });

    modalManager.openModal(config[modalName].token, true, params);
};
